import React, { useEffect } from "react";
import {
  Checkbox,
  FormControlLabel,
  Typography,
  Stack,
  Grid,
  Box,
} from "@mui/material";
import { useFormContext, useController } from "react-hook-form";

const FormCheckboxGroup = ({
  name,
  options = [],
  defaultValue = [],
  valueName = "id",
  labelName = "label",
  groupLabel = "Επιλογές", // 👈 label for the group
  disabled = false,
  vertical = false,
  ...other
}) => {
  const { control, getValues } = useFormContext();
  const { field, fieldState } = useController({
    name,
    control,
    defaultValue,
  });

  const selected = Array.isArray(field.value) ? field.value : [];

  const isSelected = (val) => selected.some((v) => String(v) === String(val));

  const toggle = (val) => {
    const next = isSelected(val)
      ? selected.filter((v) => String(v) !== String(val))
      : [...selected, val];
    field.onChange(next);
  };

  useEffect(() => {
    options?.forEach((opt) => {
      {
        if (
          opt?.isDefault &&
          !defaultValue?.includes(opt?.[valueName]) &&
          !defaultValue?.includes(opt?.[valueName]?.toString()) &&
          !selected.includes(opt?.[valueName])
        ) {
          field.onChange([...field?.value, opt?.[valueName]]);
        }
      }
    });
  }, [options]);

  return (
    <Stack spacing={1}>
      {/* Label on top */}
      <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
        {groupLabel}
      </Typography>

      <Box>
        <Grid container spacing={1}>
          {options.map((opt) => {
            const value = opt[valueName];
            const label = opt[labelName];

            return (
              <Grid item xs={12} sm={vertical ? 12 : 6} md={vertical ? 12 : 4} key={String(value)}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!(isSelected(value) || opt?.isDefault)}
                      disabled={opt?.isDefault || disabled}
                      onChange={() => toggle(value)}
                      onBlur={field.onBlur}
                      name={field.name}
                      {...other}
                    />
                  }
                  label={label}
                />
              </Grid>
            );
          })}
        </Grid>
      </Box>

      {!!fieldState.error && (
        <Typography sx={{ color: "#f44336" }}>
          {fieldState.error?.message}
        </Typography>
      )}
    </Stack>
  );
};

export default FormCheckboxGroup;
